import React from "react";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Dialog, DialogProps } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";

import { ButtonSubmit } from "components/shared";

import { PageHeader } from "components/shared/PageHeader";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
      margin: 0,
      padding: theme.spacing(3),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {/* {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon fontSize="large" style={{color: 'var(--black)'}}/>
        </IconButton>
      ) : null} */}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
    marginTop: "-50px",
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
  },
}))(MuiDialogActions);

interface DialogDetailsProps extends DialogProps {
  title: string;
  open: boolean;
  setOpen: (value: boolean) => void;
  content: React.ReactNode;
  maxWidth?: false | "md" | "xs" | "sm" | "lg" | "xl" | undefined;
}

export default function DialogDetails({
  title,
  open,
  setOpen,
  maxWidth = "md",
  content,
}: DialogDetailsProps) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth={maxWidth}
      fullWidth
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <PageHeader title={title} showUserData={false} />
      </DialogTitle>

      <DialogContent>{content}</DialogContent>

      <DialogActions>
        <ButtonSubmit autoFocus onClick={handleClose} color="primary">
          Ok
        </ButtonSubmit>
      </DialogActions>
    </Dialog>
  );
}
